import React, { useState, useEffect } from "react";
import i18n from "i18next";

// Fabric Imports

import { fetchWrapper } from "../../helpers/fetchwrapper";

import AddToBedarfDialog from "../Account/Bedarfe/AddToBedarfDialog";

import { baseUrl } from "../../helpers/constants";
import DocumentViewer from "../../Controls/DocumentViewer";

import { QuickFinderHelpImages } from "./QuickFinderHelpImages";
import useWindowSize from "../../helpers/useWindowSize";

import authService from "../api-authorization/AuthorizeService";
import { helperMethods } from "../../helpers/helperMethods";
import DownloadNotification from "../../Controls/DownloadDialog";
import {
  Button,
  Field,
  InfoLabel,
  Input,
  Text,
  Dropdown,
  Option,
  SwatchPicker,
  ImageSwatch,
  Label,
  MessageBar,
  Spinner,
  ProgressBar,
  TableSortState,
} from "@fluentui/react-components";
import {
  BoxMultipleSearchRegular,
  DismissRegular,
  IosArrowRtl24Regular,
  SearchRegular,
} from "@fluentui/react-icons";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";

import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import QuickFinderColumns from "./QuickFinderColumns";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";
import { ILuebOption } from "../../Models/ILuebOption";
import Header from "../Layout/Header";
import QuickFinderShowArticlePage from "./QuickFinderShowArticlePage";
import { useNavigate } from "react-router-dom";
import { ILSP3QueryRequestDto } from "../../Models/ILSP3QueryRequest";
import HeaderTextAnimation from "../Layout/HeaderTextAnimation";

const defaultQueryValues: ILSP3QueryRequestDto = {
  type: "allLsp3",
  artikelId: "",
  artikelIdFlachabtrieb: "",
  benennung: "",
  sachgruppe: "",
  abtriebsprofilGuid: "",
  nennweiteAbtriebsprofil: 0,
  minAbtriebsmoment: 0,
  maxAbtriebsmoment: 0,
  minOeffnung: 0,
  maxKlingenstaerke: 0,
  maxBreite: 0,
  minAchsabstand: 0,
  maxAchsabstand: 0,
  minAuskragung: 0,
  minMoment: 0,
  maxRadius: 0,
  maxKopfmass: 0,
  kennzahlAntrieb: 0,
  kennzahlAbtrieb: 0,
  maxLaenge: 0,
  minAussenlaenge: 0,
  minOeffnungsweite: 0,
  minProfiltiefe: 0,
  maxProfiltiefe: 0,
};

interface IQuickFinderProps {}

interface IDropdownOption {
  key: string;
  text: string;
  data?: any | undefined;
}

function QuickFinder(props: IQuickFinderProps) {
  const navigate = useNavigate();
  const [addBedarfIsOpen, setAddBedarfIsOpen] = useState<boolean>(false);

  const [sortState, setSortState] = useState<any>({
    sortColumn: "artikelId",
    sortDirection: "ascending",
  });

  const [addToBedarf, setAddToBedarf] =
    useState<IAddUserBedarfPosition>(/* {
    artikelId: "",
    produktId: "",
    benennungDE: "",
    benennungEN: "",
    menge: 1,
  } */);

  const [artikel, setArtikel] = useState<ILSP3ResponseDto[]>([]);
  const [preiseSichtbar, setPreiseSichtbar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partLoading, setPartLoading] = useState(false);

  const [searched, setSearched] = useState<boolean>(false);
  const [sachgruppen, setSachgruppen] = useState<IDropdownOption[]>([]);
  const [schraubprofile, setSchraubprofile] = useState<IDropdownOption[]>([]);
  const [imagespreload, setImagesPreload] = useState<any>([]);

  const [documentProps, setDocumentProps] = useState({ path: "", title: "" });

  const [clickedArticle, setClickedArticle] = useState<
    ILSP3ResponseDto | undefined
  >(undefined);

  const [queryValues, setQueryValues] = useState(defaultQueryValues);
  const handleQueryValuesChange = (name: string, val: any) => {
    setQueryValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    helperMethods.addAccessedModuleCountValue("QuickFinder");
  }, []);

  const getAbtriebszahnraeder = (artikelId: string) => {
    if (artikelId != undefined && artikelId != "") {
      setQueryValues({
        type: "abtriebszahnrad",
        artikelId: "",
        artikelIdFlachabtrieb: artikelId,
        benennung: "",
        sachgruppe: "",
        abtriebsprofilGuid: "",
        nennweiteAbtriebsprofil: 0,
        minAbtriebsmoment: 0,
        maxAbtriebsmoment: 0,
        minOeffnung: 0,
        maxKlingenstaerke: 0,
        maxBreite: 0,
        minAchsabstand: 0,
        maxAchsabstand: 0,
        minAuskragung: 0,
        minMoment: 0,
        maxRadius: 0,
        maxKopfmass: 0,
        kennzahlAntrieb: 0,
        kennzahlAbtrieb: 0,
        maxLaenge: 0,
        minAussenlaenge: 0,
        minOeffnungsweite: 0,
        minProfiltiefe: 0,
        maxProfiltiefe: 0,
      });
    }
  };

  const checkAndCorrectQueryValues = () => {
    queryValues.nennweiteAbtriebsprofil = Number(
      queryValues.nennweiteAbtriebsprofil
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );

    queryValues.minAbtriebsmoment = Number(
      queryValues.minAbtriebsmoment
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minOeffnung = Number(
      queryValues.minOeffnung
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxKlingenstaerke = Number(
      queryValues.maxKlingenstaerke
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxBreite = Number(
      queryValues.maxBreite
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minAchsabstand = Number(
      queryValues.minAchsabstand
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxAchsabstand = Number(
      queryValues.maxAchsabstand
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minAuskragung = Number(
      queryValues.minAuskragung
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minMoment = Number(
      queryValues.minMoment
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxRadius = Number(
      queryValues.maxRadius
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxKopfmass = Number(
      queryValues.maxKopfmass
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.kennzahlAntrieb = Number(
      queryValues.kennzahlAntrieb
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.kennzahlAbtrieb = Number(
      queryValues.kennzahlAbtrieb
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxLaenge = Number(
      queryValues.maxLaenge
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minAussenlaenge = Number(
      queryValues.minAussenlaenge
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minOeffnungsweite = Number(
      queryValues.minOeffnungsweite
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxAbtriebsmoment = Number(
      queryValues.maxAbtriebsmoment
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.minProfiltiefe = Number(
      queryValues.minProfiltiefe
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );
    queryValues.maxProfiltiefe = Number(
      queryValues.maxProfiltiefe
        ?.toString()
        .replace(",", ".")
        .replace(/[^\d.]/g, ""),
    );

    setQueryValues(queryValues);
  };

  const [showDownloadNotification, setShowDownloadNotification] =
    useState(false);

  const downloadKvm = (artikelId: string) => {
    setShowDownloadNotification(true);
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/documents/GetDocumentForArtikel?artikelId=${artikelId}&docKey=KVM`,
      )
      .then((data) => {
        helperMethods
          .downloadFile(data, true)
          .then((result: boolean) => {})
          .finally(() => {
            setShowDownloadNotification(false);
          });
        /* columns.resetKvmArtikelId(); */
      });
  };

  const showPdfViewer = (artikelId: string) => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/documents/GetDocumentForArtikel?artikelId=${artikelId}&docKey=PRZ`,
      )
      .then((data) => {
        if (typeof data === "object" && data.hasOwnProperty("message")) {
          if (data.message == "NO_DOCUMENT_FOUND") {
          }
        } else {
          if (
            data.docFileExtension.toLowerCase().includes("pdf") ||
            data.docFileExtension.toLowerCase().includes("stl")
          ) {
            setDocumentProps({
              path: data.docPath.replace(
                "~",
                baseUrl + "/api/documents/GetDocumentFromPath?path=",
              ),
              title: data.docFileName,
            });
          }
        }
      })
      .catch((error) => {
        if (typeof error === "object" && error.hasOwnProperty("message")) {
          if (error.message == "NO_DOCUMENT_FOUND") {
          }
        }
      });
  };

  const columns = QuickFinderColumns({
    type: queryValues.type ? queryValues.type : "allLsp3",
    showButtons: true,
    preiseSichtbar: preiseSichtbar,
    selectedAbtriebsprofilGuid: "",
    onAddBedarf: (item: IAddUserBedarfPosition) => {
      setAddToBedarf(item);
    },
    onShowPdf: (item: string | undefined) => {
      if (item != undefined) {
        showPdfViewer(item);
      }
    },
    onDownloadKvm: (item: string | undefined) => {
      if (item) {
        downloadKvm(item);
      }
    },
    onGetAbtriebsZahnräder: (item: string | undefined) => {
      if (item != undefined) {
        getAbtriebszahnraeder(item);
      }
    },
    onOrderBy: (column: string) => {
      const sortedArtikel = artikel
        .map((x) => {
          return x;
        })
        .sort((x: any, y: any) => {
          if (x[column] && y[column]) {
            if (typeof x[column] === "string" || x[column] instanceof String) {
              return x[column].localeCompare(y[column]);
            } else {
              return x[column] - y[column];
            }
          } else if (x.artikel[column] && y.artikel[column]) {
            if (
              typeof x.artikel[column] === "string" ||
              x.artikel[column] instanceof String
            ) {
              return x.artikel[column].localeCompare(y.artikel[column]);
            } else {
              return x.artikel[column] - y.artikel[column];
            }
          } else if (x.getriebe[column] && y.getriebe[column]) {
            if (
              typeof x.getriebe[column] === "string" ||
              x.getriebe[column] instanceof String
            ) {
              return x.getriebe[column].localeCompare(y.getriebe[column]);
            } else {
              return x.getriebe[column] - y.getriebe[column];
            }
          } else {
            return -1;
          }
        });
      setArtikel(sortedArtikel);

      setSortState({
        sortColumn: column,
        sortDirection:
          sortState.sortDirection == "ascending" ? "descending" : "ascending",
      });
    },
  });

  const getPreiseSichtbar = () => {
    authService.getUser().then((user: any) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result) => {
            setPreiseSichtbar(result.preiseSichtbar);
          });
      }
    });
  };

  const images = QuickFinderHelpImages();

  useEffect(() => {
    if (window.location) {
      if (window.location.search) {
        var search = window.location.search.split("=");
        var guid = search[1];
        if (guid) {
          getPartByGuid(guid);
          setSearched(true);
        }
      } else {
        setClickedArticle(undefined);
      }
    }
  }, [window.location.search]);

  const lsp3DropDownOptions: IDropdownOption[] = [
    {
      key: "allLsp3",
      text: i18n.t<string>("allLsp3"),
    },
    {
      key: "lsp3_o_inline",
      text: i18n.t<string>("lsp3_o_inline"),
    },
    {
      key: "lsp3_c_inline",
      text: i18n.t<string>("lsp3_c_inline"),
    },
    {
      key: "lsp3_o_outline",
      text: i18n.t<string>("lsp3_o_outline"),
    },
    {
      key: "lsp3_c_outline",
      text: i18n.t<string>("lsp3_c_outline"),
    },
    {
      key: "abtriebszahnrad",
      text: i18n.t<string>("abtriebszahnrad"),
    },
  ];

  const lsp3ChoiceGroupOptions: ILuebOption[] = [
    {
      key: "allLsp3",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/ALLLSP3.PNG`,
      text: i18n.t<string>("allLsp3"),
    },
    {
      key: "lsp3_o_inline",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/LSP3_O_INLINE.PNG`,
      text: i18n.t<string>("lsp3_o_inline"),
    },
    {
      key: "lsp3_c_inline",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/LSP3_C_INLINE.PNG`,
      text: i18n.t<string>("lsp3_c_inline"),
    },
    {
      key: "lsp3_o_outline",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/LSP3_O_OUTLINE.PNG`,
      text: i18n.t<string>("lsp3_o_outline"),
    },
    {
      key: "lsp3_c_outline",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/LSP3_C_OUTLINE.PNG`,
      text: i18n.t<string>("lsp3_c_outline"),
    },
    {
      key: "abtriebszahnrad",
      icon: `${baseUrl}/IMAGES/HELPIMAGES/LSP3TYPES/ABTRIEBSZAHNRAD.PNG`,
      text: i18n.t<string>("abtriebszahnrad"),
    },
  ];

  let lang: string;
  if (i18n.language.includes("de")) {
    lang = "de";
  } else {
    lang = "en";
  }

  const onChangeSachgruppe = (key: string | undefined) => {
    handleQueryValuesChange("sachgruppe", key ? key : "");
  };

  const getSachgruppen = () => {
    fetchWrapper
      .get(`${baseUrl}/api/sachgruppe/getAllKatalogSachgruppen`)
      .then((result: any[]) => {
        let options: IDropdownOption[] = [];

        if (i18n.language.includes("de")) {
          result = result.sort((a, b) =>
            a.benennungDE > b.benennungDE
              ? 1
              : b.benennungDE > a.benennungDE
              ? -1
              : 0,
          );
        } else {
          result = result.sort((a, b) =>
            a.benennungEN > b.benennungEN
              ? 1
              : b.benennungEN > a.benennungEN
              ? -1
              : 0,
          );
        }

        //options.push({ key: "empty", text: "-" });

        result.forEach((element: any) => {
          let option: IDropdownOption = {
            key: element.sachgruppeGuid,
            text: lang == "de" ? element.benennungDE : element.benennungEN,
          };
          options.push(option);
        });

        setSachgruppen(options);
        handleQueryValuesChange("sachgruppe", options[0].key);
      });
  };

  const getSchraubprofile = () => {
    fetchWrapper
      .get(`${baseUrl}/api/lsp3/GetSchraubprofile`)
      .then((result: any) => {
        let options: IDropdownOption[] = [];
        options.push({ data: undefined, key: "", text: "" });
        let images: any[] = [];
        result.forEach((element: any) => {
          let option: IDropdownOption = {
            data: element,
            key: element.schraubprofilGuid,
            text: lang == "de" ? element.displayNameDE : element.displayNameEN,
          };
          options.push(option);

          // Workaround: Bilder cachen
          const image = getImageFromPath(
            `${baseUrl}/IMAGES/SCHRAUBPROFILPICS/SOCKET_${option.data.kurzwort}.PNG`,
          );
          images.push(image);
        });

        setImagesPreload(images);
        setSchraubprofile(options);
      });
  };

  // Sachgruppen laden
  useEffect(() => {
    getPreiseSichtbar();
    getSachgruppen();
    getSchraubprofile();
  }, []);

  // Initial alle Artikel laden
  useEffect(() => {
    setArtikel([]);
    setSearched(false);
  }, [queryValues.type, queryValues.sachgruppe]);

  const getPartsByQuery = (values: any) => {
    setSearched(true);
    setLoading(true);

    fetchWrapper
      .post(`${baseUrl}/api/lsp3/byquery`, values)
      .then((result: ILSP3ResponseDto[]) => {
        result.forEach((element: ILSP3ResponseDto) => {
          if (
            !element.hasOwnProperty("benennungDE") &&
            element.hasOwnProperty("artikel")
          ) {
            element.benennungDE = element.benennungDE;
            element.benennungEN = element.benennungEN;
            element.gewicht = element.gewicht;
          }
        });
        setArtikel(result);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getPartByGuid = (guid: string) => {
    setSearched(true);
    setPartLoading(true);
    fetchWrapper
      .get(`${baseUrl}/api/lsp3/byguid?guid=${guid}`)
      .then((response) => {
        setClickedArticle(response);
        setPartLoading(false);
      })
      .catch(() => {
        console.log("PART NOT FOUND");
      });
  };

  const getImageFromPath = (url: string): any => {
    return (
      <img
        alt=""
        key={url}
        className="lueb-FixedHeight30 lueb-marginRight10"
        src={url}
        height={0}
        width={0}
      ></img>
    );
  };

  const windowSize = useWindowSize();

  const showNoLsp3ArticleFound =
    searched == true && artikel.length == 0 && loading == false;

  return (
    <>
      {showDownloadNotification && <DownloadNotification />}

      <DocumentViewer
        title={documentProps.title}
        path={documentProps.path}
        onDismiss={() => {
          /* columns.resetPrzArtikelId(); */
          setDocumentProps({ title: "", path: "" });
        }}
        canDownload={false}
      />

      <AddToBedarfDialog
        onDismiss={() => {
          /* columns.resetAddToBedarf(); */
          setAddToBedarf(undefined);
        }}
        addUserBedarfPosition={addToBedarf}
      />

      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<BoxMultipleSearchRegular fontSize={24} color="#ff6600" />}
              onClick={() => {
                navigate("/quickfinder");
              }}
              appearance="subtle"
            >
              {i18n.t<string>("quickfinder").toLocaleUpperCase()}
            </Button>
            {clickedArticle && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  {(clickedArticle.benennungDE != undefined ||
                    clickedArticle.benennungEN != undefined) && (
                    <HeaderTextAnimation
                      text={
                        clickedArticle.benennungDE != undefined &&
                        clickedArticle.benennungEN != undefined
                          ? i18n.language.includes("de")
                            ? clickedArticle.artikelId +
                              " - " +
                              clickedArticle.benennungDE
                            : clickedArticle.artikelId +
                              " - " +
                              clickedArticle.benennungEN
                          : ""
                      }
                    />
                  )}
                  {clickedArticle.artikel != null &&
                    (clickedArticle.artikel?.benennungDE != undefined ||
                      clickedArticle.artikel?.benennungEN != undefined) && (
                      <>
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            transition:
                              "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                          }}
                        >
                          {clickedArticle.artikel.benennungDE != undefined &&
                          clickedArticle.artikel.benennungEN != undefined
                            ? i18n.language.includes("de")
                              ? (
                                  clickedArticle.artikel.artikelId +
                                  " - " +
                                  clickedArticle.artikel.benennungDE
                                )
                                  .split("")
                                  .map((char, charIndex) => {
                                    if (char != " ") {
                                      return (
                                        <span
                                          key={charIndex}
                                          style={{
                                            display: "inline-block",
                                            opacity: 0,
                                            transform: "translateX(-10px)",
                                            animation: `fadeInMove 0.135s ease forwards ${
                                              charIndex * 0.0225
                                            }s`,
                                          }}
                                        >
                                          {char}
                                        </span>
                                      );
                                    } else
                                      return <div style={{ width: "5px" }} />;
                                  })
                              : (
                                  clickedArticle.artikel.artikelId +
                                  " - " +
                                  clickedArticle.benennungEN
                                )
                                  .split("")
                                  .map((char, charIndex) => {
                                    if (char != " ") {
                                      return (
                                        <span
                                          key={charIndex}
                                          style={{
                                            display: "inline-block",
                                            opacity: 0,
                                            transform: "translateX(-10px)",
                                            animation: `fadeInMove 0.135s ease forwards ${
                                              charIndex * 0.0225
                                            }s`,
                                          }}
                                        >
                                          {char}
                                        </span>
                                      );
                                    } else
                                      return <div style={{ width: "5px" }} />;
                                  })
                            : ""}
                        </span>
                        {
                          <style>
                            {` 
                                                @keyframes fadeInMove { 
                                                  to { 
                                                    opacity: 1; 
                                                    transform: translateX(0); 
                                                  } 
                                                } 
                                              `}
                          </style>
                        }
                      </>
                    )}
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      {clickedArticle == undefined && !partLoading && (
        <>
          <div className="lueb-ContentBlock">
            {windowSize.width > 1024 && (
              <div style={{ paddingRight: 5, marginBottom: "18px" }}>
                <Label weight="semibold">{i18n.t<string>("typ")}</Label>
                <SwatchPicker
                  aria-label="SwatchPicker default"
                  selectedValue={queryValues.type}
                  onSelectionChange={(ev: any, val: any) => {
                    handleQueryValuesChange(
                      "type",
                      val ? val.selectedValue : "",
                    );
                  }}
                >
                  <div style={{ display: "flex", flexFlow: "wrap" }}>
                    {" "}
                    {lsp3ChoiceGroupOptions.map((image: ILuebOption) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "170px",
                          margin: "2px",
                        }}
                      >
                        <ImageSwatch
                          disabled={loading}
                          style={{
                            width: "170px",
                            height: "135px",
                          }}
                          key={image.key}
                          src={image.icon ? image.icon : ""}
                          value={typeof image.key == "string" ? image.key : ""}
                          aria-label={image.text ? image.text : ""}
                        />
                        <Label
                          style={{ textAlign: "center" }}
                          weight="semibold"
                        >
                          {image.text}
                        </Label>
                      </div>
                    ))}
                  </div>
                </SwatchPicker>
              </div>
            )}
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <StackShim horizontal wrap tokens={{ childrenGap: 5 }}>
                {windowSize.width <= 1024 && (
                  <StackItemShim>
                    <Field label={i18n.t<string>("typ")}>
                      <Dropdown
                        selectedOptions={
                          queryValues.type ? [queryValues.type] : []
                        }
                        value={
                          queryValues.type
                            ? lsp3DropDownOptions.find(
                                (x) => x.key == queryValues.type,
                              )?.text
                            : ""
                        }
                        onOptionSelect={(ev, data) => {
                          handleQueryValuesChange(
                            "type",
                            data ? data.optionValue : "",
                          );
                        }}
                        disabled={loading}
                      >
                        {lsp3DropDownOptions.map((option: IDropdownOption) => (
                          <Option value={option.key}>{option.text}</Option>
                        ))}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                )}
                <StackItemShim>
                  <Field
                    style={{
                      minWidth: 300,
                    }}
                    label={i18n.t<string>("artikelId")}
                    validationMessage={
                      queryValues.artikelId.length > 0 &&
                      queryValues.artikelId.length < 4
                        ? i18n.t<string>("min4Chars")
                        : ""
                    }
                  >
                    <Input
                      value={queryValues.artikelId}
                      name="artikelId"
                      onChange={(ev, val) =>
                        handleQueryValuesChange(
                          "artikelId",
                          val.value ? val.value.replace(/\s/g, "") : "",
                        )
                      }
                    />
                  </Field>
                </StackItemShim>
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <Text weight="bold" size={400}>
                                {i18n.t<string>("artikelIdFlachabtriebHint")}
                              </Text>
                            }
                          >
                            {i18n.t<string>("artikelIdFlachabtrieb")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("artikelIdFlachabtrieb")}</div>
                        )
                      }
                      id={"artikelIdFlachabtriebId"}
                    >
                      <Input
                        value={queryValues.artikelIdFlachabtrieb}
                        name="artikelIdFlachabtrieb"
                        onChange={(ev, val) =>
                          handleQueryValuesChange(
                            "artikelIdFlachabtrieb",
                            val.value ? val.value.replace(/\s/g, "") : "",
                          )
                        }
                      />
                    </Field>
                  </StackItemShim>
                )}
                <StackItemShim>
                  <Field
                    label={i18n.t<string>("benennung")}
                    style={{
                      minWidth: 300,
                    }}
                    validationMessage={
                      queryValues.benennung &&
                      queryValues.benennung.length > 0 &&
                      queryValues.benennung.length < 4
                        ? i18n.t<string>("min4Chars")
                        : ""
                    }
                  >
                    <Input
                      value={queryValues.benennung}
                      name="benennungId"
                      onChange={(ev, val) =>
                        handleQueryValuesChange(
                          "benennung",
                          val.value ? val.value : "",
                        )
                      }
                    />
                  </Field>
                </StackItemShim>

                {queryValues.type == "allLsp3" && (
                  <StackItemShim>
                    <Field label={i18n.t<string>("sachgruppe")}>
                      <Dropdown
                        selectedOptions={
                          queryValues.sachgruppe ? [queryValues.sachgruppe] : []
                        }
                        value={
                          queryValues.artikelId.length > 0 ||
                          (queryValues.benennung?.length &&
                            queryValues.benennung?.length > 0)
                            ? ""
                            : sachgruppen.find(
                                (x) => x.key == queryValues.sachgruppe,
                              )?.text
                            ? sachgruppen.find(
                                (x) => x.key == queryValues.sachgruppe,
                              )?.text
                            : ""
                        }
                        onOptionSelect={(ev, data) => {
                          onChangeSachgruppe(data.optionValue);
                        }}
                        disabled={
                          loading ||
                          queryValues.artikelId.length > 0 ||
                          (queryValues.benennung?.length != undefined &&
                            queryValues.benennung?.length > 0)
                        }
                      >
                        {sachgruppen.map((option: IDropdownOption) => (
                          <Option value={option.key}>{option.text}</Option>
                        ))}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                )}

                {queryValues.type != "allLsp3" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                {queryValues.type && (
                                  <img
                                    alt=""
                                    src={
                                      images.getImage(
                                        queryValues.type,
                                        "abtriebsprofil",
                                      )?.src
                                    }
                                  />
                                )}
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("abtriebsprofil")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("abtriebsprofil")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("abtriebsprofil")}</div>
                        )
                      }
                    >
                      <Dropdown
                        selectedOptions={
                          queryValues.abtriebsprofilGuid
                            ? [queryValues.abtriebsprofilGuid]
                            : []
                        }
                        value={
                          schraubprofile.find(
                            (x) => x.key == queryValues.abtriebsprofilGuid,
                          )?.text
                        }
                        onOptionSelect={(ev, data) => {
                          if (data.optionValue) {
                            handleQueryValuesChange(
                              "abtriebsprofilGuid",
                              data.optionValue,
                            );
                          } else {
                            handleQueryValuesChange("abtriebsprofilGuid", "");
                          }
                        }}
                        disabled={loading}
                      >
                        {schraubprofile.map((option: IDropdownOption) => (
                          <Option text={option.text} value={option.key}>
                            <div>
                              {option?.data && (
                                <img
                                  alt={option.text}
                                  className="lueb-FixedHeight30 lueb-marginRight10"
                                  src={`${baseUrl}/IMAGES/SCHRAUBPROFILPICS/SOCKET_${option?.data?.kurzwort}.PNG`}
                                ></img>
                              )}
                              {option.text}
                            </div>
                          </Option>
                        ))}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                )}

                {queryValues.type != "allLsp3" && (
                  <StackItemShim>
                    <Field
                      label={
                        <div>{i18n.t<string>("nennweiteAbtriebsprofil")}</div>
                      }
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.nennweiteAbtriebsprofil
                            ? queryValues.nennweiteAbtriebsprofil.toString()
                            : ""
                        }
                        name="nennweiteAbtriebsprofilId"
                        onChange={(ev, val: any) => {
                          handleQueryValuesChange(
                            "nennweiteAbtriebsprofil",
                            val.value,
                          );
                        }}
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field label={i18n.t<string>("minAbtriebsmomentM")}>
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>Nm</Text>}
                          value={
                            queryValues.minAbtriebsmoment
                              ? queryValues.minAbtriebsmoment.toString()
                              : ""
                          }
                          name="abtriebsmomentId1"
                          onChange={(ev, val: any) => {
                            handleQueryValuesChange(
                              "minAbtriebsmoment",
                              val.value,
                            );
                          }}
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}

                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field label={i18n.t<string>("maxAbtriebsmomentM")}>
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>Nm</Text>}
                          value={
                            queryValues.maxAbtriebsmoment
                              ? queryValues.maxAbtriebsmoment.toString()
                              : ""
                          }
                          name="abtriebsmomentId2"
                          onChange={(ev, val: any) => {
                            handleQueryValuesChange(
                              "maxAbtriebsmoment",
                              val.value,
                            );
                          }}
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}

                {(queryValues.type == "lsp3_o_inline" ||
                  queryValues.type == "lsp3_o_outline") && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  alt=""
                                  src={
                                    images.getImage(
                                      queryValues.type,
                                      "minOeffnung",
                                    )?.src
                                  }
                                />
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("minOeffnung")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("minOeffnung")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("minOeffnung")}</div>
                        )
                      }
                      id={"artikelIdFlachabtriebId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.minOeffnung
                            ? queryValues.minOeffnung.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("minOeffnung", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {(queryValues.type == "lsp3_o_inline" ||
                  queryValues.type == "lsp3_o_outline") && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            id="maxKopfmassId"
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  alt=""
                                  src={
                                    images.getImage(
                                      queryValues.type,
                                      "maxKopfmass",
                                    )?.src
                                  }
                                />
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("maxKopfmass")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("maxKopfmass")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("maxKopfmass")}</div>
                        )
                      }
                      id={"maxKopfmassId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.maxKopfmass
                            ? queryValues.maxKopfmass.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("maxKopfmass", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type != "allLsp3" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                {queryValues.type && (
                                  <img
                                    alt=""
                                    src={
                                      images.getImage(
                                        queryValues.type,
                                        "maxRadius",
                                      )?.src
                                    }
                                  />
                                )}
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("maxRadius")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("maxRadius")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("maxRadius")}</div>
                        )
                      }
                      id={"maxRadiusId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.maxRadius
                            ? queryValues.maxRadius.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("maxRadius", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field
                        label={
                          windowSize.height > 500 && windowSize.width > 600 ? (
                            <InfoLabel
                              info={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {queryValues.type && (
                                    <img
                                      alt=""
                                      src={
                                        images.getImage(
                                          queryValues.type,
                                          "maxKlingenstaerke",
                                        )?.src
                                      }
                                    />
                                  )}
                                  <Text weight="bold" size={400}>
                                    {i18n.t<string>("maxKlingenstaerke")}
                                  </Text>
                                </div>
                              }
                            >
                              {i18n.t<string>("maxKlingenstaerke")}
                            </InfoLabel>
                          ) : (
                            <div>{i18n.t<string>("maxKlingenstaerke")}</div>
                          )
                        }
                        id={"maxKlingenstaerkeId"}
                      >
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>mm</Text>}
                          value={
                            queryValues.maxKlingenstaerke
                              ? queryValues.maxKlingenstaerke.toString()
                              : ""
                          }
                          onChange={(ev, val: any) =>
                            handleQueryValuesChange(
                              "maxKlingenstaerke",
                              val.value,
                            )
                          }
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field
                        label={
                          windowSize.height > 500 && windowSize.width > 600 ? (
                            <InfoLabel
                              info={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {queryValues.type && (
                                    <img
                                      alt=""
                                      src={
                                        images.getImage(
                                          queryValues.type,
                                          "maxBreite",
                                        )?.src
                                      }
                                    />
                                  )}
                                  <Text weight="bold" size={400}>
                                    {i18n.t<string>("maxBreite")}
                                  </Text>
                                </div>
                              }
                            >
                              {i18n.t<string>("maxBreite")}
                            </InfoLabel>
                          ) : (
                            <div>{i18n.t<string>("maxBreite")}</div>
                          )
                        }
                        id={"maxBreiteId"}
                      >
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>mm</Text>}
                          value={
                            queryValues.maxBreite
                              ? queryValues.maxBreite.toString()
                              : ""
                          }
                          onChange={(ev, val: any) =>
                            handleQueryValuesChange("maxBreite", val.value)
                          }
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field
                        label={
                          windowSize.height > 500 && windowSize.width > 600 ? (
                            <InfoLabel
                              info={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {queryValues.type && (
                                    <img
                                      alt=""
                                      src={
                                        images.getImage(
                                          queryValues.type,
                                          "minAchsabstand",
                                        )?.src
                                      }
                                    />
                                  )}
                                  <Text weight="bold" size={400}>
                                    {i18n.t<string>("minAchsabstand")}
                                  </Text>
                                </div>
                              }
                            >
                              {i18n.t<string>("minAchsabstand")}
                            </InfoLabel>
                          ) : (
                            <div>{i18n.t<string>("minAchsabstand")}</div>
                          )
                        }
                        id={"minAchsabstandId"}
                      >
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>mm</Text>}
                          value={
                            queryValues.minAchsabstand
                              ? queryValues.minAchsabstand.toString()
                              : ""
                          }
                          onChange={(ev, val: any) =>
                            handleQueryValuesChange("minAchsabstand", val.value)
                          }
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field
                        label={
                          windowSize.height > 500 && windowSize.width > 600 ? (
                            <InfoLabel
                              info={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {queryValues.type && (
                                    <img
                                      alt=""
                                      src={
                                        images.getImage(
                                          queryValues.type,
                                          "maxAchsabstand",
                                        )?.src
                                      }
                                    />
                                  )}
                                  <Text weight="bold" size={400}>
                                    {i18n.t<string>("maxAchsabstand")}
                                  </Text>
                                </div>
                              }
                            >
                              {i18n.t<string>("maxAchsabstand")}
                            </InfoLabel>
                          ) : (
                            <div>{i18n.t<string>("maxAchsabstand")}</div>
                          )
                        }
                        id={"maxAchsabstandId"}
                      >
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>mm</Text>}
                          value={
                            queryValues.maxAchsabstand
                              ? queryValues.maxAchsabstand.toString()
                              : ""
                          }
                          onChange={(ev, val: any) =>
                            handleQueryValuesChange("maxAchsabstand", val.value)
                          }
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}
                {queryValues.type != "allLsp3" &&
                  queryValues.type != "abtriebszahnrad" && (
                    <StackItemShim>
                      <Field
                        label={
                          windowSize.height > 500 && windowSize.width > 600 ? (
                            <InfoLabel
                              info={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {queryValues.type && (
                                    <img
                                      alt=""
                                      src={
                                        images.getImage(
                                          queryValues.type,
                                          "minAuskragung",
                                        )?.src
                                      }
                                    />
                                  )}
                                  <Text weight="bold" size={400}>
                                    {i18n.t<string>("minAuskragung")}
                                  </Text>
                                </div>
                              }
                            >
                              {i18n.t<string>("minAuskragung")}
                            </InfoLabel>
                          ) : (
                            <div>{i18n.t<string>("minAuskragung")}</div>
                          )
                        }
                        id={"minAuskragungId"}
                      >
                        <Input
                          type="number"
                          contentAfter={<Text size={400}>mm</Text>}
                          value={
                            queryValues.minAuskragung
                              ? queryValues.minAuskragung.toString()
                              : ""
                          }
                          onChange={(ev, val: any) =>
                            handleQueryValuesChange("minAuskragung", val.value)
                          }
                          onBlur={() => checkAndCorrectQueryValues()}
                        />
                      </Field>
                    </StackItemShim>
                  )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  alt=""
                                  src={
                                    images.getImage(
                                      queryValues.type,
                                      "maxLaenge",
                                    )?.src
                                  }
                                />
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("maxLaenge")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("maxLaenge")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("maxLaenge")}</div>
                        )
                      }
                      id={"maxLaengeId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.maxLaenge
                            ? queryValues.maxLaenge.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("maxLaenge", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  alt=""
                                  src={
                                    images.getImage(
                                      queryValues.type,
                                      "minAussenlaenge",
                                    )?.src
                                  }
                                />
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("minAussenlaenge")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("minAussenlaenge")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("minAussenlaenge")}</div>
                        )
                      }
                      id={"minAussenlaengeId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.minAussenlaenge
                            ? queryValues.minAussenlaenge.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("minAussenlaenge", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        windowSize.height > 500 && windowSize.width > 600 ? (
                          <InfoLabel
                            info={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  alt=""
                                  src={
                                    images.getImage(
                                      queryValues.type,
                                      "minOeffnungsweite",
                                    )?.src
                                  }
                                />
                                <Text weight="bold" size={400}>
                                  {i18n.t<string>("minOeffnungsweite")}
                                </Text>
                              </div>
                            }
                          >
                            {i18n.t<string>("minOeffnungsweite")}
                          </InfoLabel>
                        ) : (
                          <div>{i18n.t<string>("minOeffnungsweite")}</div>
                        )
                      }
                      id={"minOeffnungsweiteId"}
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.minOeffnungsweite
                            ? queryValues.minOeffnungsweite.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange(
                            "minOeffnungsweite",
                            val.value,
                          )
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        <InfoLabel>
                          {i18n.t<string>("maxAbtriebsmoment")}
                        </InfoLabel>
                      }
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>Nm</Text>}
                        value={
                          queryValues.maxAbtriebsmoment
                            ? queryValues.maxAbtriebsmoment.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange(
                            "maxAbtriebsmoment",
                            val.value,
                          )
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        <InfoLabel>
                          {i18n.t<string>("minProfiltiefe")}
                        </InfoLabel>
                      }
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>mm</Text>}
                        value={
                          queryValues.minProfiltiefe
                            ? queryValues.minProfiltiefe.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("minProfiltiefe", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
                {queryValues.type == "abtriebszahnrad" && (
                  <StackItemShim>
                    <Field
                      label={
                        <InfoLabel>
                          {i18n.t<string>("maxProfiltiefe")}
                        </InfoLabel>
                      }
                    >
                      <Input
                        type="number"
                        contentAfter={<Text size={400}>Nm</Text>}
                        value={
                          queryValues.maxProfiltiefe
                            ? queryValues.maxProfiltiefe.toString()
                            : ""
                        }
                        onChange={(ev, val: any) =>
                          handleQueryValuesChange("maxProfiltiefe", val.value)
                        }
                        onBlur={() => checkAndCorrectQueryValues()}
                      />
                    </Field>
                  </StackItemShim>
                )}
              </StackShim>
            </div>

            <div style={{ marginTop: "6px" }}>
              <Button
                style={{ marginRight: "5px" }}
                disabled={
                  loading ||
                  (queryValues.artikelId.length > 0 &&
                    queryValues.artikelId.length < 4) ||
                  (queryValues.benennung != undefined &&
                    queryValues.benennung?.length > 0 &&
                    queryValues.benennung?.length < 4)
                }
                appearance="primary"
                icon={<SearchRegular />}
                onClick={() => {
                  getPartsByQuery(queryValues);
                }}
              >
                {i18n.t<string>("suchen")}
              </Button>

              <Button
                icon={<DismissRegular />}
                disabled={loading}
                onClick={() => {
                  defaultQueryValues.type = queryValues.type;
                  setQueryValues(defaultQueryValues);
                  setArtikel([]);
                }}
              >
                {i18n.t<string>("clearSearchParameter")}
              </Button>
            </div>
          </div>

          {loading && (
            <Field
              validationMessage={i18n.t<string>("loadingQuickFinder")}
              validationState="none"
            >
              <ProgressBar thickness="large" />
            </Field>
          )}

          {!loading && (
            <div className="lueb-ContentBlock">
              <LuebPagedDataGrid
                loading={loading}
                items={artikel}
                columns={columns}
                resizableColumns={true}
                sortable
                sortState={sortState}
                columnSizingOptions={{
                  actions: { defaultWidth: 50, minWidth: 50 },
                  artikelId: { defaultWidth: 70, minWidth: 70 },
                }}
              />

              {searched == false && (
                <div style={{ marginTop: 10 }}>
                  <MessageBar intent={"info"}>
                    {i18n.t<string>("startLsp3Search")}
                  </MessageBar>
                </div>
              )}

              {showNoLsp3ArticleFound && (
                <div style={{ marginTop: 10 }}>
                  <MessageBar intent={"warning"}>
                    {i18n.t<string>("noLsp3ArticleFound")}
                  </MessageBar>
                </div>
              )}

              {preiseSichtbar && (
                <div style={{ marginTop: 10 }}>
                  <Text style={{ textAlign: "right", marginTop: 20 }}>
                    <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
                    {i18n.t<string>("priceNote")}
                  </Text>
                </div>
              )}
            </div>
          )}
        </>
      )}
      {clickedArticle != undefined && (
        <>
          <QuickFinderShowArticlePage
            clickedArticle={clickedArticle}
            onShowPdf={(item: string) => {
              showPdfViewer(item);
            }}
            onDownloadKvm={(item: string) => {
              downloadKvm(item);
            }}
            onFindAbtriebszahnrad={(item: string) => {
              navigate("/quickfinder");
              setClickedArticle(undefined);
              getAbtriebszahnraeder(item);
              var newQuery = { ...queryValues };
              newQuery.type = "abtriebszahnrad";
              newQuery.artikelIdFlachabtrieb = item;
              getPartsByQuery(newQuery);
            }}
            onAddBedarf={(item: IAddUserBedarfPosition) => {
              setAddToBedarf(item);
            }}
          />
        </>
      )}
      <div>
        {imagespreload.map(function (d: any, idx: any) {
          return d;
        })}
      </div>
    </>
  );
}

export default QuickFinder;
